var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCovid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.376 20.435c-.666-.614-1.279-1.384-1.298-1.79-.002-.038-.003-.052.048-.1 1.433-1.369 2.535-3.76 2.842-5.094.16-.087.65-.292 1.898-.419.283-.029.557-.049.8-.063-.28 3.095-1.896 5.8-4.29 7.466zM12 22.125a9.366 9.366 0 0 1-3.113-.53c.382-.462.834-1.016 1.215-1.503 1.123-1.439.529-5.439.216-8.202a1.797 1.797 0 0 1-.013-.281c.14-.038.396-.069.593-.093 1.099-.134 2.937-.358 4.702-2.583.729-.92.977-1.956.718-2.997-.344-1.379-1.575-2.737-3.658-4.038 4.774.332 8.593 4.257 9.012 9.193-.388.02-.857.055-1.335.115-1.322.165-2.87.508-3.097 1.707-.163.863-1.107 3.082-2.329 4.25a1.99 1.99 0 0 0-.63 1.58c.049.97.76 1.932 1.419 2.624a9.352 9.352 0 0 1-3.7.758zm-4.824-1.333C4.236 19.032 2.289 15.75 2.289 12c0-4.694 3.042-8.569 7.071-9.748 1.59.705 4.79 2.437 5.217 4.156.071.285.11.733-.363 1.33-1.305 1.645-2.536 1.795-3.525 1.916-.557.068-1.084.132-1.518.465-.795.61-.677 1.65-.639 1.99.16 1.411.372 3.102.415 4.538.054 1.83-.21 2.222-.24 2.261a82.315 82.315 0 0 1-1.531 1.884zM12 0C5.64 0 .49 5.367.49 12c0 6.632 5.148 12 11.51 12 6.36 0 11.51-5.367 11.51-12 0-6.632-5.148-12-11.51-12z",
    fill: "#272726",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovid);
export default __webpack_public_path__ + "static/media/covid.44fa69754f1773144d0088e6978e19cd.svg";
export { ForwardRef as ReactComponent };